/**
 * Tick label helpers and DOM selectors for bar-chart x-axis measurement.
 */

export const TICK_HEIGHT = 20;
export const CHART_X_AXIS_TICK_LABEL_ATTR = 'data-chart-x-tick-label';
export const CHART_X_AXIS_TICK_LABEL_SELECTOR = `[${CHART_X_AXIS_TICK_LABEL_ATTR}="true"]`;
export const CHART_X_AXIS_TRUNCATE_PROBE_ATTR =
  'data-chart-x-truncate-probe-label';
export const CHART_X_AXIS_TRUNCATE_PROBE_SELECTOR = `[${CHART_X_AXIS_TRUNCATE_PROBE_ATTR}="true"]`;

/** Fallback label width when Recharts has not yet injected axis metrics. */
export const FALLBACK_TICK_WIDTH = 100;

export interface TickPayload {
  value?: string;
}

/** Returns trimmed tick text from the Recharts tick payload. */
export const getTickLabel = (payload?: TickPayload): string =>
  payload?.value?.trim() ?? '';
